import get from 'lodash/get';
import camelCase from 'lodash/camelCase';

import { AGENCY_BRANDS, BRAND, MY_BRANDS } from 'utils/brands';
import { getDefaultMeta } from 'utils/influencersMeta';

import type {
  InfluencerMetaKey,
  InfluencerTile,
  State
} from 'types';

type BrandType =
  | typeof AGENCY_BRANDS
  | typeof BRAND
  | typeof MY_BRANDS;

type Props = {
  influencer: InfluencerTile
};

function isInfluencerInMetaSelector(
  metaKey: InfluencerMetaKey,
  {
    influencersMeta
  }: State,
  {
    influencer: { id }
  }: Props,
  brandTypes: Array<BrandType>
): boolean {
  return brandTypes.some(
    type => get(influencersMeta, [id, metaKey, camelCase(type)], []).length
  );
}

export function influencerMetaSelector(
  state: State,
  {
    influencerId
  }: {
    influencerId: number
  }
) {
  return state.influencersMeta[influencerId] || getDefaultMeta();
}

const getAvailableBrandTypes = (state: State): Array<BrandType> => {
  const brandTypes: Array<BrandType> = [BRAND];
  const { account, organizations } = state;
  const { currentOrganization, list: organizationsList } = organizations;
  const brandOrganizationsCount = organizationsList.filter(o => o.type === 'brand').length;

  if (currentOrganization?.id && account.mapByAgencyOrganizationId[currentOrganization.id]) {
    brandTypes.push(AGENCY_BRANDS);
  }

  if (brandOrganizationsCount > 1) {
    brandTypes.push(MY_BRANDS);
  }

  return brandTypes;
};

export function isInfluencerShortlistedSelector(state: State, props: Props): boolean {
  return isInfluencerInMetaSelector(
    'campaigns',
    state,
    props,
    [BRAND, MY_BRANDS, AGENCY_BRANDS]
  );
}

export function isInfluencerInListsSelector(state: State, props: Props): boolean {
  return isInfluencerInMetaSelector(
    'lists',
    state,
    props,
    [BRAND, MY_BRANDS, AGENCY_BRANDS]
  );
}

export function isInfluencerInNotesSelector(state: State, props: Props): boolean {
  return isInfluencerInMetaSelector(
    'notes',
    state,
    props,
    getAvailableBrandTypes(state)
  );
}
